import React, { useMemo, useState } from "react";
import "./App.css";

const PRODUCTS = [
  {
    id: 1,
    name: "Smartwatch HW8",
    category: "Relojes",
    price: 45000,
    Dropid: 1746018,
    image:
      "/hw8.webp",
    badge: "Más vendido",
  },
  {
    id: 2,
    name: "Smartwatch L5",
    category: "Relojes",
    price: 43000,
    Dropid: 1144120,
    image:
      "https://media.falabella.com/falabellaCO/154335304_01/w=1500,h=1500,fit=cover",
    badge: "En Tendencia",
  },
  {
    id: 3,
    name: "Audífonos Air31",
    category: "Tecnología",
    price: 15000,
    Dropid: 2000048,
    image:
      "https://http2.mlstatic.com/D_NQ_NP_751987-MLM98517003100_112025-O.webp",
    badge: "Perfecto en combo",
  },
  {
    id: 4,
    name: "Mini Celular Infantil",
    category: "Tecnología",
    price: 85000,
    Dropid: 490198,
    image:
      "https://talego.com.co/wp-content/uploads/2025/12/1766161437IMG_7128-600x398.jpeg",
    badge: "Más vendido",
  },
  {
    id: 5,
    name: "Linterna de Mano Recargable",
    category: "Hogar",
    price: 15000,
    Dropid: 1873839,
    image:
      "https://http2.mlstatic.com/D_Q_NP_2X_760343-CBT92210829351_092025-T.webp",
    badge: "Nuevo",
  },
  {
    id: 6,
    name: "Ahorrador de Energía",
    category: "Hogar",
    price: 17000,
    Dropid: 2013688,
    oldPrice: 69900,
    image:
      "https://exitocol.vteximg.com.br/arquivos/ids/28917582/ahorro-de-energia-caja-de-ahorro-de-electricidad-hogar.jpg?v=638858845769770000",
    badge: "Popular",
  },
  {
    id: 7,
    name: "Smartwatch C30 Pro Militar",
    category: "Tecnología",
    price: 60000,
    Dropid: 2100003,
    image:
      "https://http2.mlstatic.com/D_NQ_NP_751692-MCO92049131223_092025-O.webp",
    badge: "Más vendido",
  },
  {
    id: 8,
    name: "Smartwatch C30 Pro + Correa de Metal",
    category: "Relojes",
    price: 72000,
    Dropid: 2191728,
    image:
      "https://http2.mlstatic.com/D_NQ_NP_751692-MCO92049131223_092025-O.webp",
    badge: "Popular",
  },
  {
    id: 9,
    name: "Smartwatch HT46",
    category: "Relojes",
    price: 80000,
    Dropid: 2191727,
    image:
      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTYcc-MeQT_DUrZ0Znsi3cZmAHDNwBeOOB-zQejh4DHjWwfYcnI6NjyQh6N&s=10",
    badge: "Popular",
  },
  {
    id: 9,
    name: "Linterna Multifuncional Recargable",
    category: "Hogar",
    price: 17000,
    Dropid: 2188369,
    image:
      "https://d39ru7awumhhs2.cloudfront.net/colombia/products/2188369/1782598467Captura%20de%20pantalla%202026-06-27%20171244.png",
    badge: "En Tendencia",
  },
  {
    id: 10,
    name: "Reloj Phantom Árabe + Batería + Herramienta de recorte + Paño de limpieza",
    category: "Tecnología",
    price: 28000,
    Dropid: 2013228,
    image:
      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRLenYrSSKZy1Z2Cqrmt562I4piYUVnyc5EmcsNPDEKOVIplRm7SHyahYJJ&s=10",
    badge: "En Tendencia",
  },
  {
    id: 11,
    name: "Smartwatch D20 Niños",
    category: "Tecnología",
    price: 25900,
    Dropid: 466842,
    image:
      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcS-fkUqiQ9KOsm8OITRZRYuAJkDUXjlYdm8UIJNHgvMWKPTFH3Wrf0wJEU&s=10",
    badge: "En Tendencia",
  },
];

// const CATEGORIES = ["Todos", "Relojes", "Tecnología", "Hogar"];

function formatPrice(price) {
  return new Intl.NumberFormat("es-CO", {
    style: "currency",
    currency: "COP",
    maximumFractionDigits: 0,
  }).format(price);
}

function App() {
  const [category, setCategory] = useState("Todos");
  const [search, setSearch] = useState("");
  const [cart, setCart] = useState([]);
  const [showCart, setShowCart] = useState(false);

  const filteredProducts = useMemo(() => {
    return PRODUCTS.filter((product) => {
      const matchesCategory =
        category === "Todos" || product.category === category;

      const matchesSearch = product.name
        .toLowerCase()
        .includes(search.toLowerCase());

      return matchesCategory && matchesSearch;
    });
  }, [category, search]);

  const addToCart = (product) => {
    setCart((current) => {
      const exists = current.find((item) => item.id === product.id);

      if (exists) {
        return current.map((item) =>
          item.id === product.id
            ? { ...item, quantity: item.quantity + 1 }
            : item
        );
      }

      return [...current, { ...product, quantity: 1 }];
    });
  };

  const removeFromCart = (id) => {
    setCart((current) =>
      current
        .map((item) =>
          item.id === id
            ? { ...item, quantity: item.quantity - 1 }
            : item
        )
        .filter((item) => item.quantity > 0)
    );
  };

  const totalItems = cart.reduce((sum, item) => sum + item.quantity, 0);

  const totalPrice = cart.reduce(
    (sum, item) => sum + item.price * item.quantity,
    0
  );

  const sendWhatsApp = () => {
    if (!cart.length) return;

    const productsText = cart
      .map(
        (item) =>
          `• ${item.name} x${item.quantity} - ${formatPrice(
            item.price * item.quantity
          )}`
      )
      .join("\n");

    const message = `Hola, quiero realizar un pedido:

${productsText}

Total: ${formatPrice(totalPrice)}

Quedo atento/a para continuar con el pedido.`;

    window.open(
      `https://wa.me/573002936267?text=${encodeURIComponent(message)}`,
      "_blank"
    );
  };

  return (
    <div className="app">
      {/* NAVBAR */}
      <header className="navbar">
        <div className="container nav-content">
          <div className="logo">
  <img
    className="logo-image"
    src="/favicon.ico"
    alt="Enlazo"
  />

  <div className="logo-text">
    <strong>ENLAZO</strong>
    <span>Catálogo</span>
  </div>
</div>

          <nav>
            <a href="#inicio">Inicio</a>
            <a href="#catalogo">Catálogo</a>
            <a href="#nosotros">Nosotros</a>
          </nav>

          <button
            className="cart-button"
            onClick={() => setShowCart(true)}
          >
            🛒
            {totalItems > 0 && (
              <span className="cart-count">{totalItems}</span>
            )}
          </button>
        </div>
      </header>

      {/* HERO */}
      <section className="hero" id="inicio">
        <div className="container hero-content">
          <div className="hero-text">
            <div className="eyebrow">
              <span></span>
              PRODUCTOS SELECCIONADOS
            </div>

            <h1>
              Encuentra productos
              <br />
              que <em>sí quieres tener.</em>
            </h1>

            <p>
              Explora nuestro catálogo de productos. Calidad, buenos precios y despacho
              rápido.
            </p>

            <a href="#catalogo" className="hero-button">
              Ver catálogo
              <span>→</span>
            </a>
          </div>

          <div className="hero-visual">
            <div className="hero-circle"></div>

            <div className="floating-card card-one">
              <span>⭐</span>
              <div>
                <strong>Productos</strong>
                <small>Seleccionados</small>
              </div>
            </div>

            <div className="floating-card card-two">
              <span>🚚</span>
              <div>
                <strong>Despacho rápido</strong>
                <small>En Colombia</small>
              </div>
            </div>

            <div className="hero-product">
              <img
                src={PRODUCTS[0].image}
                alt={PRODUCTS[0].name}
              />
            </div>
          </div>
        </div>
      </section>

      {/* CATEGORIES */}
      <section className="categories">
        <div className="container">
          <div className="category-grid">
            <div className="category-intro">
              <span>EXPLORA</span>
              <h2>Busca por categoría</h2>
            </div>

            <button
              className={category === "Todos" ? "category active" : "category"}
              onClick={() => setCategory("Todos")}
            >
              <span className="category-icon">✦</span>
              <strong>Todos</strong>
              <small>Ver todo</small>
            </button>

            <button
              className={
                category === "Relojes" ? "category active" : "category"
              }
              onClick={() => setCategory("Relojes")}
            >
              <span className="category-icon">⌚</span>
              <strong>Relojes</strong>
              <small>Smartwatches</small>
            </button>

            <button
              className={
                category === "Tecnología"
                  ? "category active"
                  : "category"
              }
              onClick={() => setCategory("Tecnología")}
            >
              <span className="category-icon">◉</span>
              <strong>Tecnología</strong>
              <small>Gadgets</small>
            </button>

            <button
              className={
                category === "Hogar" ? "category active" : "category"
              }
              onClick={() => setCategory("Hogar")}
            >
              <span className="category-icon">⌂</span>
              <strong>Hogar</strong>
              <small>Soluciones</small>
            </button>
          </div>
        </div>
      </section>

      {/* CATALOG */}
      <main className="catalog" id="catalogo">
        <div className="container">
          <div className="catalog-header">
            <div>
              <span className="section-label">NUESTRO CATÁLOGO</span>
              <h2>Productos destacados</h2>
            </div>

            <div className="search-box">
              <span>⌕</span>
              <input
                type="text"
                placeholder="Buscar producto..."
                value={search}
                onChange={(e) => setSearch(e.target.value)}
              />
            </div>
          </div>

          <div className="products-grid">
            {filteredProducts.map((product) => (
              <article className="product-card" key={product.id}>
                <div className="product-image">
                  <span className="product-badge">
                    {product.badge}
                  </span>

                  <img src={product.image} alt={product.name} />

                  <button
                    className="quick-add"
                    onClick={() => addToCart(product)}
                  >
                    +
                  </button>
                </div>

                <div className="product-info">
                  <span className="product-category">
                    {product.category}
                  </span>

                  <h3>{product.name}</h3>

                  <div className="price">
                    <strong>{formatPrice(product.price)}</strong>
                  </div>
                  <div className="price">
                    <text>Dropi id: <strong>{product.Dropid}</strong></text>
                  </div>

                  <button
                    className="add-button"
                    onClick={() => window.open("https://drive.google.com/drive/folders/1r6Z2tuHG9C_2Rdn50NtvOkyPf_0Q1-rk?usp=drive_link", "_blank")}
                  >
                    Ver creativos
                    <span>→</span>
                  </button>
                  <button
                    className="add-button"
                    onClick={() => addToCart(product)}
                  >
                    Agregar al pedido
                    <span>→</span>
                  </button>
                </div>
              </article>
            ))}
          </div>

          {filteredProducts.length === 0 && (
            <div className="empty">
              <div>⌕</div>
              <h3>No encontramos productos</h3>
              <p>Prueba con otro nombre o categoría.</p>
            </div>
          )}
        </div>
      </main>

      {/* BANNER */}
      <section className="banner" id="nosotros">
        <div className="container banner-content">
          <div>
            <span>ENLAZO</span>
            <h2>Productos. Logística. Soluciones.</h2>
            <p>
              Trabajamos para conectar buenos productos con
              personas que buscan una compra fácil y confiable.
            </p>
          </div>

          <div className="banner-number">
            <strong>24/7</strong>
            <span>Catálogo disponible</span>
          </div>
        </div>
      </section>

      {/* FOOTER */}
      <footer>
        <div className="container footer-content">
          <div className="footer-brand">
            <div className="logo">
  <img
    className="logo-image"
    src="/favicon.ico"
    alt="Enlazo"
  />

  <div className="logo-text">
    <strong>ENLAZO</strong>
    <span>Catálogo</span>
  </div>
</div>
            <p>
              Tu ganador está aquí
            </p>
          </div>

          <div className="footer-links">
            <strong>Contacto</strong>
            <a
              href="https://wa.me/573002936267"
              target="_blank"
              rel="noreferrer"
            >
              WhatsApp
            </a>
            <a href="mailto:ventas@enlazo.co">
              ventas@enlazo.co
            </a>
          </div>
        </div>

        <div className="copyright">
          © {new Date().getFullYear()} Enlazo S.A.S. Todos los
          derechos reservados.
        </div>
      </footer>

      {/* CART */}
      {showCart && (
        <div
          className="cart-overlay"
          onClick={() => setShowCart(false)}
        >
          <aside
            className="cart"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="cart-header">
              <div>
                <span>ENLAZO</span>
                <h2>Tu pedido</h2>
              </div>

              <button onClick={() => setShowCart(false)}>
                ×
              </button>
            </div>

            {cart.length === 0 ? (
              <div className="cart-empty">
                <div>🛒</div>
                <h3>Tu pedido está vacío</h3>
                <p>
                  Agrega productos del catálogo para comenzar.
                </p>
              </div>
            ) : (
              <>
                <div className="cart-items">
                  {cart.map((item) => (
                    <div className="cart-item" key={item.id}>
                      <img src={item.image} alt={item.name} />

                      <div className="cart-item-info">
                        <strong>{item.name}</strong>
                        <span>{formatPrice(item.price)}</span>

                        <div className="quantity">
                          <button
                            onClick={() => removeFromCart(item.id)}
                          >
                            −
                          </button>

                          <b>{item.quantity}</b>

                          <button
                            onClick={() => addToCart(item)}
                          >
                            +
                          </button>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>

                <div className="cart-footer">
                  <div className="total">
                    <span>Total</span>
                    <strong>{formatPrice(totalPrice)}</strong>
                  </div>

                  <button
                    className="whatsapp-button"
                    onClick={sendWhatsApp}
                  >
                    <span>◉</span>
                    Solicitar pedido por WhatsApp
                  </button>
                </div>
              </>
            )}
          </aside>
        </div>
      )}
    </div>
  );
}

export default App;
